import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import TextInput from '../../../components/UIComponent/TextInput';

const itemColdefs = [
    {
        field: "itemDrawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.09,
        flex: 0.9,
        filter: true,
    },
    {
        field: "itemItemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "pendingQty",
        headerName: "Pending Qty",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "salesReturnNo",
        headerName: "Sales Return No",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

const challanColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "returnNo",
        headerName: "Return no",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "returnDate",
        headerName: "Return Date",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
        floatingFilter: true,
    },

];

const vendorColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "itemDrawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.08,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "pendingQty",
        headerName: "Pending Qty",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "storeTransferQty",
        headerName: "Store Transfer qty",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "returnQuantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.8,
        filter: true,
        floatingFilter: true,
    },
];

export const MrsRegisterPopup = (props) => {
    return (
        <ModalBasic
            id="mrs-register"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            {!props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Sales Return Inward</span>
                    <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>Sales In no</label>
                            <TextInput type='text'
                                id='salesReturnInNo' name='salesReturnInNo'
                                value={props.registerObject.salesReturnInNo}
                                handleChange={(event) => props.handleChangeForRegister(event, 'salesReturnInNo')}
                                className={props.validState?.error?.salesReturnInNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Sales In date</label>
                            <TextInput type='date'
                                id='salesInDate' name='salesInDate'
                                value={props.registerObject.salesInDate}
                                handleChange={(event) => props.handleChangeForRegister(event, 'salesInDate')}
                                className={props.validState?.error?.salesInDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Auth. employee</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select material"
                                options={props.registerObject.EmployeeList}
                                value={props.registerObject.idEmployee ? props.registerObject.EmployeeList.find(x => x.value === props.registerObject.idEmployee) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idEmployee", 'registerObject')
                                }
                                className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                            /> */}
                            <TextInput type='text'
                                id='usp_Users' name='usp_Users'
                                value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Select Vendor</label>
                            <MultiSelectDropdown
                                drpIdentity="Select vendor"
                                options={props.partyAccountList}
                                value={props.registerObject.idVendor ? props.partyAccountList.find(x => x.value === props.registerObject.idVendor) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idVendor", 'registerObject')
                                }
                                className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                            />

                        </div>
                        {/* <div className='input-grp'>
                            <label>Inv. type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select inv"
                                options={props.invTyleList}
                                value={props.registerObject.idInv ? props.invTyleList.find(x => x.value === props.registerObject.idInv) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idInv")
                                }
                                className={props.validState?.error?.idInv !== undefined ? "error" : ""}
                            />
                        </div> */}
                        <div className='item-grp grid grid-cols-4 gap-2.5 col-span-4'>
                            <div className='input-grp row-span-2 col-span-2'>
                                <label>Address</label>
                                <textarea rows={4}
                                    id='address' name='address'
                                    value={props.registerObject.address}
                                    onChange={(event) => props.handleChangeForRegister(event, 'address')}
                                    className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                                />
                            </div>

                            <div className='btn-grp flex items-center gap-2.5 col-span-2 mt-5'>
                                <button
                                    className="save-btn btns py-[10px] px-[20px]"
                                    onClick={() => props.addSalesReturn()}
                                >
                                    Add Sales Return
                                </button>

                            </div>
                        </div>

                    </div>
                    <span className="text-blue text-[16px] font-semibold">Item details</span>
                    <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>Drawing no</label>
                            <TextInput type='text'
                                id='drawingNo' name='drawingNo'
                                value={props.itemObject.drawingNo}
                                handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                                className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp col-span-1'>
                            <label>Select type</label>
                            <TextInput type='text'
                                id='type' name='type'
                                value={props.itemObject.type}
                                handleChange={(event) => props.handleChangeForItem(event, 'type')}
                                className={props.validState?.error?.type !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Item name</label>
                            <TextInput type='text'
                                id='itemName' name='itemName'
                                value={props.itemObject.itemName}
                                handleChange={(event) => props.handleChangeForItem(event, 'itemName')}
                                className={props.validState?.error?.itemName !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Quantity</label>
                            <TextInput type='text'
                                id='quantity' name='quantity'
                                value={props.itemObject.quantity}
                                handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                                className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Remarks</label>
                            <TextInput type='text'
                                id='remarks' name='remarks'
                                value={props.itemObject.remarks}
                                handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                                className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                            />
                        </div>
                        {props.itemObject.keyId >= 0 ?
                            <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                                <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insertItem("Update")}>Update</button>
                                <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Clear</button>
                                <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.delete()}>Delete</button>
                            </div>
                            : null}
                    </div>
                    <div className="register-table h-[40vh]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.itemRowData}
                                columnDefs={itemColdefs}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onRowDoubleClicked={props.onItemRowDataClicked}
                            />
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        {/* <button className="print-btn btns">Print</button>
                        <button className="edit-btn btns">Preview</button> */}
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            )}
            {props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Material job work inward selection</span>
                    <div className="process-table h-[35vh] mt-[5px] mb-2 pb-[8px] border-b border-slate-200">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.firstSalesReturnList}
                                columnDefs={challanColdefs}
                                onCellClicked={props.hanldeClickMaterialJobWorkInwardSelection}
                                rowSelection="multiple"
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onRowDataUpdated={(params) => {
                                    if (params.api && props.firstSalesReturnList.length > 0) {
                                        params.api.getRowNode(0)?.setSelected(true);
                                    }
                                }}
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onSelectionChanged(selectedRows);
                                }}
                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Challan item details</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.secondSalesReturnList}
                                columnDefs={vendorColdefs}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                rowSelection="multiple"
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onSelectionItemsChanged(selectedRows);
                                }}
                                onRowDataUpdated={(params) => {
                                    params.api.selectAll();
                                }}
                            />
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.addProduct()}>Add products</button>
                        <button className="delete-btn btns" onClick={() => props.back()}>Back</button>
                    </div>
                </div>
            )}

        </ModalBasic>
    )
}